import { render, staticRenderFns } from "./RequestInfo.vue?vue&type=template&id=68389188&scoped=true"
import script from "./RequestInfo.vue?vue&type=script&lang=js"
export * from "./RequestInfo.vue?vue&type=script&lang=js"
import style0 from "./RequestInfo.vue?vue&type=style&index=0&id=68389188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68389188",
  null
  
)

export default component.exports